import siteConfig from "site-config";

type ActionPayload = Partial<{
    url: string;
    body: any;
}>;

export const buildFetchParams =
    (method: string) =>
    ({ payload }: { payload: ActionPayload }) => ({
        method,
        url: siteConfig.api + payload.url,
        body: payload.body,
        headers: {
            "X-Requested-With": "XMLHttpRequest",
            module: "default",
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });

/**
 *
 * @param error thrown from an Observable
 * @returns text error returned from a service communicated via GRPC or undefined
 */
export const pickGrpcError = (error) => {
    return error?.xhr?.response?.error;
};
